import {
    faBars,
    faBook,
    faBullseye, faChartPie,
    faCheck, faCreditCard,
    faChevronDown,
    faChevronLeft,
    faChevronRight,
    faClock, faCloud, faCog, faDatabase, faDollarSign, faDownload, faEdit,
    faEnvelope,
    faExclamationTriangle, faEye, faEyeSlash,
    faFile,
    faFrog,
    faIdBadge,
    faLock,
    faLockOpen,
    faMouse, faMousePointer,
    faPlus,
    faPlusCircle,
    faRocket,
    faRuler, faSave,
    faSearch, faServer,
    faShoppingCart, faShoePrints, faSignOutAlt,
    faStickyNote,
    faSync,
    faTicketAlt,
    faTimes,
    faToolbox,
    faTrash,
    faUpload,
    faUser, faUserCog,
    faUsers,
    faVrCardboard,
    faWalking,
    faTable, faChevronUp, faFileSignature, faFileAlt, faTags, faShieldAlt, faCalendar,
    faLink, faArrowsAltH, faXRay, faCube, faWifi, faUserTag, faPeopleArrows,     faList, faCubes, faKey, faFlask, faPercent, faChild, faBriefcase, faTag, faStore,
    faSlidersH, faLayerGroup,
    faPowerOff, faColumns, faExternalLinkAlt, faPlay, faKeyboard, faDesktop, faBoxOpen, faGift,
    faBolt, faUserCheck, faCodeBranch, faVideo,
    faVideoSlash, faGavel, faTools, faVectorSquare, faRunning, faTachometerAlt, faHandPointer, faGem, faLocationArrow, faBezierCurve, faHandRock, faHeart, faExchangeAlt, faCrosshairs, faUserFriends, faFish, faHourglassHalf, faSignal, faHistory, faStopwatch, faWater, faArchive, faBell
} from '@fortawesome/free-solid-svg-icons'
import { library } from "@fortawesome/fontawesome-svg-core";
import { faBitcoin, faChrome, faDiscord, faInternetExplorer, faPaypal } from "@fortawesome/free-brands-svg-icons";


library.add(
    faTrash, faBars, faTimes,
    faUpload, faPaypal, faDiscord, faBitcoin,
    faChevronLeft, faChevronRight, faCheck, faCreditCard, faUser,
    faEnvelope, faSearch, faExclamationTriangle, faChevronDown,
    faLock, faLockOpen, faToolbox, faUsers, faRocket, faShoppingCart,
    faSync, faPlus, faFile, faPlusCircle, faBook, faTicketAlt, faIdBadge,
    faMouse, faMousePointer, faRuler, faBullseye, faVrCardboard, faFrog, faWalking,
    faClock, faStickyNote, faChartPie, faDownload, faCloud, faServer, faDatabase,
    faEye, faEyeSlash, faShoePrints, faDollarSign, faCog, faSignOutAlt, faUserCog, faEdit, faSave, faTable,
    faChevronUp, faFileSignature, faFileAlt, faTags, faShieldAlt, faChrome,
    faCalendar, faLink, faArrowsAltH, faXRay, faCube, faWifi, faUserTag, faPeopleArrows,
    faList, faCubes, faKey, faFlask, faPercent, faChild, faBriefcase, faTag, faStore,
    faSlidersH, faLayerGroup,
    faPowerOff, faColumns, faExternalLinkAlt, faPlay, faKeyboard, faDesktop, faBoxOpen, faGift,
    faBolt, faUserCheck, faCodeBranch, faVideo,
    faVideoSlash, faGavel, faTools, faVectorSquare, faRunning, faTachometerAlt, faHandPointer, faGem, faLocationArrow, faBezierCurve, faHandRock, faHeart, faExchangeAlt, faCrosshairs, faUserFriends, faFish, faHourglassHalf, faSignal, faHistory, faStopwatch, faWater, faArchive, faBell
);
